import React from "react";
import { useTestTimePageVM } from "./TestTimePageViewModel";
import TestTimePageView from "./TestTimePageView";

const TestTimePage: React.FC = () => {
  const vm = useTestTimePageVM();

  return <TestTimePageView actions={vm.actions} />;
};

export default TestTimePage;